export default __webpack_public_path__ + "static/media/fashion1.9cb638cf.jpg";